import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ConfirmPasswordForm from '../components/auth/ConfirmPasswordForm';

import { useAuth } from '../components/context';

import { authApi } from '../api';
import { RECAPTCHA_SKIP } from '../utils/appConfig';

function ResetPassword({ t, user, setAlert }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { token, email } = useParams();
  const { onLogin, env } = useAuth();
  const [confirmedHandle, setConfirmedHandle] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [showUsername, setShowUsername] = useState(false);
  const [usernameOptions, setUsernameOptions] = useState([]);
  const from = location.state && location.state.from ? location.state.from : '/';

  const authenticate = async (values, { setSubmitting }) => {
    try {
      const response = await authApi.authenticate({
        handle: user.entity.handle,
        password: values.password,
        env,
      });
      onLogin(response);
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
    } finally {
      setSubmitting(false);
    }
  };

  const changePassword = async (values, { setSubmitting, resetForm, initialValues }) => {
    try {
      await authApi.changePassword(values.password);
      authenticate(values, { setSubmitting });
      setAlert({ message: t('resetPassword.form.messages.success'), variant: 'success' });
      navigate({ pathname: from });
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
      resetForm({ values: initialValues });
    }
  };

  const resetPassword = async (values, { setSubmitting, resetForm, initialValues }) => {
    try {
      let response;
      const handleConfirmed = values.handle ? values.handle : confirmedHandle;
      if (!RECAPTCHA_SKIP) {
        response = await authApi.resetPassword(
          token,
          handleConfirmed,
          values.password,
          values.ctoken
        );
      } else {
        response = await authApi.resetPassword(token, handleConfirmed, values.password);
      }
      setAlert({ message: response.message, variant: 'success' });
      navigate({ pathname: user ? from : '/login' });
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
      resetForm({ values: initialValues });
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!token && !user) navigate({ pathname: '/login' });
    async function fetchAccountsData() {
      const response = await authApi.getAccounts({
        token: token,
        handle: 'placeholder_handle',
      });
      if (!response.success) {
        setAlert({ message: response.message, variant: 'warning' });
        navigate({ pathname: '/login' });
      } else if (response.total_count && response.total_count > 1) {
        if (response.accounts.length > 0) {
          const accounts = [];
          response.accounts.forEach((loginHandle) => {
            accounts.push({ label: loginHandle, value: loginHandle });
          });
          setUsernameOptions(accounts);
        }
        setShowUsername(true);
      } else {
        setConfirmedHandle(response.accounts[0]);
      }
    }
    async function decryptEmail() {
      const response = await authApi.decryptEmail({
        email: decodeURIComponent(email),
      });
      if (response.success && response.email) {
        setUserEmail(response.email);
      }
    }
    if (token && !user) {
      fetchAccountsData();
      if (email) {
        decryptEmail();
      }
    }
  }, []);

  return (
    <Container className="login set-password main-content-container p-3 py-md-5">
      {user ? (
        <Row>
          <Col className="mx-auto g-0" xl={5} lg={6} md={8} sm={10} xs={12}>
            <Card>
              <Card.Body>
                <ConfirmPasswordForm onSubmit={user ? changePassword : resetPassword} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <ConfirmPasswordForm
          onSubmit={user ? changePassword : resetPassword}
          usernameOptions={usernameOptions}
          showUsername={showUsername}
          userEmail={userEmail}
        />
      )}
    </Container>
  );
}

export default ResetPassword;
